/* eslint no-console: 0 */

import { date, debug, hash } from 'settings/custom/build'

console.log(date)
console.log(hash)

const colors = {
  BUTTON: 'darkseagreen',
  RADIO: 'darkseagreen',
  TOGGLE: 'darkseagreen',
  STATE: 'steelblue',
  ACTION: 'lightsteelblue',
  SOUND: 'tan',
  WARNING: 'red',
  STAGE: 'gray',
  SERVER: 'yellow',
}

function color(type) {
  const back = colors[type] || 'silver'
  return `background: ${back}; color: black;`
}

export function log(message, type = '') {
  if (debug) {
    if (typeof message == 'string') {
      console.log(`%c${message}`, color(type))
    }
    else {
      console.log(message)
    }
  }
}
